import { createContext, useContext, useEffect, useState } from "react";
import Step, { StepResponseData } from "../../core/models/Step";
import NetworkingServiceError from "../../core/services/network/NetworkServiceError";
import appConfig from "../../util/appConfig";

// This context allows the app to get the Steps information

export type StepError = NetworkingServiceError;

// Create type
export type StepsDataType = {
  stepsResponseData?: StepResponseData;
  setStepsResponseData: (responseData?: StepResponseData) => void;
  selectedStep?: Step;
  setSelectedStep: (step?: Step) => void;
  stepLoading: boolean;
  setStepLoading: (isLoading: boolean) => void;
  stepsError: StepError | undefined;
  setStepsError: (error?: StepError) => void;
};

// Create context for type
// @ts-ignore
export const StepsDataContext = createContext<StepsDataType>();

//Create provider of the context
export const StepsDataProvider = ({ children }: any) => {
  const [selectedStep, setSelectedStep] = useState<Step>();
  const [stepsResponseData, setStepsResponseData] =
    useState<StepResponseData>();
  const [stepLoading, setStepLoading] = useState<boolean>(false);
  const [stepsError, setStepsError] = useState<StepError>();

  const value = {
    stepsResponseData,
    setStepsResponseData,
    selectedStep,
    setSelectedStep,
    stepLoading,
    setStepLoading,
    stepsError,
    setStepsError,
  };
  useEffect(() => {
    if (appConfig.debugSteps && selectedStep)
      console.debug("[Steps][SelectedStep] ", selectedStep);
  }, [selectedStep]);

  useEffect(() => {
    if (appConfig.debugSteps && stepsResponseData)
      console.debug("[Steps][stepsResponseData] ", stepsResponseData);
  }, [stepsResponseData]);

  useEffect(() => {
    if (appConfig.debugSteps && stepLoading)
      console.debug("[Steps][StepLoading] ", stepLoading);
  }, [stepLoading]);

  useEffect(() => {
    if (appConfig.debugSteps && stepsError)
      console.warn(
        "[Steps][Error] ",
        stepsError?.userMessage(),
        stepsError?.debugMessage()
      );
  }, [stepsError]);
  return (
    <StepsDataContext.Provider value={value}>
      {children}
    </StepsDataContext.Provider>
  );
};

export const useStepsContext = () => useContext(StepsDataContext);
